import { ApolloClient } from '@apollo/client';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

const routerDevTools = false;

// Define the shape of the context shared by all routes in the app
export interface RouterContext {
	apolloClient: ApolloClient<unknown>;
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: () => (
		<>
			<Outlet />
			{routerDevTools && <TanStackRouterDevtools />}
		</>
	),
});
